import React from 'react';
import styles from './Form.module.scss';

export default function SectionTitle({ children }) {
  return <label className={styles.section_title}>{children}</label>;
}
